module.exports = __webpack_public_path__ + "static/img/validCode.9e7b7784.svg";